import { NavigateFunction } from 'react-router-dom';
import { getPartOfCurrentQueryString } from 'helpers';
import { QueryParams } from 'types/enums';

export const redirectIfCurrentPageIsEmpty = ({
    currentPage,
    totalPages,
    pathname,
    search,
    navigate,
}: {
    currentPage: number;
    totalPages: number;
    pathname: string;
    search: string;
    navigate: NavigateFunction;
}) => {
    if (currentPage !== 1 && currentPage > totalPages) {
        const queryString = getPartOfCurrentQueryString({
            routerQueryString: search,
            queriesToExclude: [QueryParams.page],
        });

        navigate({
            pathname: pathname,
            search: queryString
                ? `?${queryString}&page=${totalPages}`
                : `?page=${totalPages}`,
        });
    }
};
